import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import ChatPanel from "./ChatPanel";

export default function FloatingConta() {
  const [open, setOpen] = useState(false);
  return <div className="floating-conta" data-testid="floating-el-conta"><button className="floating-conta-button" onClick={() => setOpen(!open)} data-testid="floating-el-conta-button">{open ? <X /> : <MessageCircle />}<span>El Conta</span></button>{open && <div className="floating-conta-window" data-testid="floating-el-conta-window"><ChatPanel /></div>}</div>;
}